import { createRoute } from "@tanstack/react-router";

import { lazyWithRetry } from "@shared/lib/lazy";

import { renderProtectedRoute, renderRoute } from "@app/router/routeElements";
import { rootRoute } from "@app/router/rootRoute";

const integrationsIndex = lazyWithRetry(() => import("./routes/index"));
const suppliersPage = lazyWithRetry(() => import("./routes/suppliers"));
const telegramPage = lazyWithRetry(() => import("./routes/telegram"));
const integrationNew = lazyWithRetry(() => import("./routes/new"));
const integrationDetail = lazyWithRetry(() => import("./routes/[id]"));
const integrationEdit = lazyWithRetry(() => import("./routes/[id]/edit"));
const integrationLogs = lazyWithRetry(() => import("./routes/[id]/logs"));
const webhooksIndex = lazyWithRetry(() => import("./routes/webhooks"));
const webhookNew = lazyWithRetry(() => import("./routes/webhooks/new"));
const webhookEdit = lazyWithRetry(() => import("./routes/webhooks/[id]/edit"));
const connectorsIndex = lazyWithRetry(() => import("./routes/connectors"));
const connectorDetail = lazyWithRetry(
  () => import("./routes/connectors/[key]"),
);
const connectorOauthCallback = lazyWithRetry(
  () => import("./routes/connectors/[key]/oauth/callback"),
);

const integrationsIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/integrations",
  component: () =>
    renderProtectedRoute(integrationsIndex, {
      requirePerms: ["integrations:read"],
    }),
});

const integrationNewRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/integrations/new",
  component: () =>
    renderProtectedRoute(integrationNew, {
      requirePerms: ["integrations:write"],
    }),
});

const integrationDetailRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/integrations/$id",
  component: () =>
    renderProtectedRoute(integrationDetail, {
      requirePerms: ["integrations:read"],
    }),
});

const integrationEditRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/integrations/$id/edit",
  component: () =>
    renderProtectedRoute(integrationEdit, {
      requirePerms: ["integrations:write"],
    }),
});

const integrationLogsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/integrations/$id/logs",
  component: () =>
    renderProtectedRoute(integrationLogs, {
      requirePerms: ["integrations:read"],
    }),
});

const webhooksIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/integrations/webhooks",
  component: () => renderProtectedRoute(webhooksIndex, {requirePerms: ["integrations:read"]}),
});

const webhookNewRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/integrations/webhooks/new",
  component: () => renderRoute(webhookNew),
});

const webhookEditRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/integrations/webhooks/$id/edit",
  component: () => renderProtectedRoute(webhookEdit, {requirePerms: ["integrations:read"]}),
});

const connectorsIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/integrations/connectors",
  component: () =>
    renderProtectedRoute(connectorsIndex, {
      requirePerms: ["integrations:read"],
    }),
});

const connectorDetailRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/integrations/connectors/$key",
  component: () =>
    renderProtectedRoute(connectorDetail, {
      requirePerms: ["integrations:read"],
    }),
});

const connectorOauthCallbackRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/integrations/connectors/$key/oauth/callback",
  component: () => renderRoute(connectorOauthCallback),
});

export const integrationsRouteTree = [
  createRoute({ getParentRoute: () => rootRoute, path: "/integrations/telegram",
    component: () => renderProtectedRoute(telegramPage, { requirePerms: ["integrations:read"] }) }),
  createRoute({
    getParentRoute: () => rootRoute,
    path: "/integrations/suppliers",
    component: () =>
      renderProtectedRoute(suppliersPage, {
        requirePerms: ["integrations:read"],
      }),
  }),
  integrationsIndexRoute,
  integrationNewRoute,
  integrationDetailRoute,
  integrationEditRoute,
  integrationLogsRoute,
  webhooksIndexRoute,
  webhookNewRoute,
  webhookEditRoute,
  connectorsIndexRoute,
  connectorDetailRoute,
  connectorOauthCallbackRoute,
];
